const LISTE_ECHEANCES_A_PAYER = {
  title: 'Liste des échéances à payer',
  onglet: {
    listePaiementDirect: 'Paiements directs',
    listePaiementSurFacture: 'Paiements sur factures',
    listePaiementARapprocher: 'Factures non parvenues',
  },
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des échéances à payer',
  },
  actions: {
    replanifier: 'Replanifier',
    creationLotPaiement: 'Créer les paiements',
    filtre: 'Filtre',
    search: 'Rechercher',
    edit: 'Modifier',
    reload: 'Actualiser',
  },
  cumul: {
    bap: 'BAP {libelle} :',
    total: '{libelle} :',
  },
  tab: {
    codeAvenantBail: 'Bail',
    indexation: 'Index.',
    codeMateriel: 'Code matériel',
    nomBailleur: 'Bailleur',
    adresse: 'Adresse dispositif',
    periodeEcheance: 'Période échéance',
    dateEcheance: 'Date échéance',
    dateFinBail: 'Date fin bail',
    etatBail: 'Etat bail',
    blocageReglement: 'Bloc.',
    motifBlocage: 'Motif',
    montantEcheanceHT: 'Mnt. HT',
    montantEcheanceTTC: 'Mnt. TTC',
    modeReglement: 'Mode(s) règlement',
    commentaireLigneCommande: 'Commentaire échéance a payer',
    commentaireCommande: 'Commentaire échéance bail',
    validateur: 'Validateur(s)',
    villePanneau: 'Ville dispositif',
    refPaiement: 'Référence paiement',
    bonAPayer: 'BAP',
    materielType: 'Type matériel',
    formatType: 'Format matériel',
    voirDetail: 'Voir détail faces',
  },
  tabEcheanceAPayerFace: {
    codeFace: 'Faces/Ecrans',
    codeProduit: 'Produits',
    montantEcheanceHT: 'Mnt. HT',
    montantEcheanceTTC: 'Mnt. TTC',
    commentaireLigneCommande: 'Commentaire échéance a payer',
    validateur: 'Validateur(s)',
    refPaiement: 'Référence paiement',
    bonAPayer: 'BAP',
    affectation: 'Affectation(s)',
  },
  yes: 'Oui',
  no: 'Non',
  displayEchAnt: 'Afficher les échéances antérieures non payées ({total})',
  masquerEchAnt: 'Masquer les échéances antérieures non payées',
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence(s)',
    modeReglement: 'Mode de règlement',
    codeAvenantBail: 'Bail',
    codeFace: 'Faces/Ecrans',
    nomBailleur: 'Bailleur',
    blocageReglement: 'Blocage paiement',
    motifBlocage: 'Motif blocage',
    montantEcheanceHT: 'Montant HT',
    montantEcheanceTTC: 'Montant TTC',
    commentaire: 'Commentaire',
    etatBail: 'Etat du bail',
    datesFinContrat: 'Date fin du bail',
    villePanneau: 'Ville du produit',
    adresse: 'Adresse du produit',
    refPaiement: 'Référence paiement',
    validateur: 'Validateur(s)',
    bonAPayer: 'Bon à payer',
    estIndexe: 'Avec indexation',
    au: 'au',
    yes: 'Oui',
    no: 'Non',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    errors: {
      dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin',
    },
  },
  infoAffectation: {
    title: 'Affectation(s) du matériel {code}',
    noAffectation: 'Aucune affectation pour ce matériel',
  },
  popUpReplanification: {
    title: 'Modifier la date d\'échéance',
    date: 'Date d\'échéance',
    commentaire: 'Commentaire',
    actions: {
      cancel: 'Annuler',
      validate: 'Valider',
    },
    messages: {
      errors: {
        datePlanification: 'date d\'échéance',
        posePlanification: 'date d\'échéance',
      },
    },
  },
  popUpEditEcheancesAPayer: {
    title: 'Modifier le/les échéance(s) à payer',
    validateur: 'Validateur(s)',
    bonAPayer: 'Bon à payer',
    refPaiement: 'Référence paiement',
    commentaire: 'Commentaire',
    actions: {
      cancel: 'Annuler',
      validate: 'Valider',
    },
    messages: {
      errors: {
        refPaiement: 'Référence paiement',
        commentaire: 'Commentaire',
      },
    },
  },
  popUpCreationLotPaiement: {
    title: 'Créer les lots de paiements',
    nom: 'Nom',
    libelle: 'Paiement du {month} / {year}',
    datePaiement: 'Date paiement (date comptable)',
    banque: 'Banque',
    modePaiement: 'Mode de paiement',
    nombrePaiement: 'Nombre de paiements',
    montantLot: 'Montant lot TTC',
    action: {
      cancel: 'Annuler',
      create: 'Créer',
      redirection: 'Rediriger vers les lots de paiements après création',
    },
    errors: {
      banque: 'Banque',
      modePaiement: 'Mode de paiement',
      datePaiement: 'Date paiement',
      billBadState: 'L\'état de la facture n\'est pas correct pour la création d\'un lot de paiement.',
      montantShouldBePositive: 'Le montant de l\'échéance ne peut pas être inférieure à zéro.',
      shouldHaveModeReglement: 'Le mode de règlement est obligatoire pour la création d\'un lot de paiment.',
      oneConfigurationPerPaymentType: 'Un seul paramétrage n\'est autorisé par mode de règlement.',
      modeReglementAchat: 'Le mode de règlement {modeReglement} n\'a pas d\'action d\'achat.',
      PaymentPlanOfBillContainsPaymentTypeNotConfigured: 'L\'echeancier de paiement de la facture {codeFacture} contient le mode de règlement {modeReglement} qui n\'est pas configuré.',
      PaymentTypeOfPayerNotConfigured: 'Le payeur de la commande {codeCommande} a le mode de règlement {modeReglement} qui n\'est pas configuré',
      savedBilledStateRequired: 'L\'échéance à payer {codeCommande} doit être à l\'état "enregistrée" ou "facturée"',
      delaiReglementWithNombreJourDecalageAndFinDeMoisNotFound: 'Pas de délai de règlement avec un nombre de jours de décalage à zéro et une fin de mois désactivée.',
    },
    success: {
      creationLotPaiement: 'Le lot de paiement a été créé avec succès',
    },
  },
  messages: {
    successEdit: 'Vos échéances ont été modifiées avec succès. Actualisez votre écran',
  },
};

export default LISTE_ECHEANCES_A_PAYER;
